export default {
  "content": "<title>Language</title><path d=\"M48 112h288M192 64v48m80 336l96-224 96 224m-162.5-64h133M281.3 112S257 206 199 277 80 384 80 384\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M256 336s-35-27-72-75-56-85-56-85\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};